import React from 'react';
import PropTypes from 'prop-types';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { copyToClipboard } from 'Helpers/Utils';

const useStyles = buildUseStyles('CopyWrapper', () => ({
  copyWrapper: {
    cursor: 'pointer',
  },
}));

const CopyWrapper = ({
  children,
  value,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { displaySuccess } = useSnackbarContext();

  const onClick = () => {
    copyToClipboard(value);
    displaySuccess('Copied!');
  };

  return (
    <div role={'presentation'} className={classes.copyWrapper} onClick={onClick}>
      {children}
    </div>
  );
};

CopyWrapper.defaultProps = {};

CopyWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.string.isRequired,
};

export default CopyWrapper;
